import api from "APP_ROOT/api";
import { SUCCESS } from "LIB/submission/constants";
import { buildFilters } from "MODULES/Shipping/actions";
import { createChannel } from "APP_ROOT/cable";
import * as actionTypes from "./actionTypes";
import { shipmentsPagination } from "./pagination";

export function set(shipment) {
  return { type: actionTypes.SET, shipment };
}

export const {
  search,
  setFilter,
  stateLocator,
  pageActions: dashboardPageActions
} = shipmentsPagination;

export function reloadShippingSilent() {
  return (dispatch, getState) => {
    const currentState = getState();
    const paginator = stateLocator(currentState);
    const filters = buildFilters(paginator);

    return api.shipments.search(filters).then(({ data }) => {
      dispatch(dashboardPageActions.resetResults(data.results));
    });
  };
}

export function fetch(id) {
  return dispatch =>
    api.shipments.show(id).then(({ data }) => dispatch(set(data)));
}

export function update(id, data) {
  return dispatch =>
    api.shipments.update(id, data).then(resp => {
      dispatch(set(resp.data));
      return SUCCESS;
    });
}

export function toggleCheck(shipment) {
  const serializedUser = JSON.parse(window.localStorage.getItem("user"));

  const data = {
    checked_by_full_name: serializedUser.full_name,
    checked_at: shipment.checked ? null : new Date(),
    checked: !shipment.checked,
    checked_by_id: shipment.checked ? null : serializedUser.id,
    updated_at: new Date(),
    updated_by: {
      id: serializedUser.id,
      name: serializedUser.full_name
    }
  };

  return dashboardPageActions.updateAsync(
    shipment.id,
    data,
    api.shipments.toggleCheck(shipment.id)
  );
}

let channel = null;

export function unsubscribe() {
  return () => {
    if (channel) {
      channel.unsubscribe();
      channel = null;
    }
  };
}

export function onDisconnect() {
  return unsubscribe();
}

export function subscribe(onReceive = reloadShippingSilent()) {
  return dispatch => {
    if (!channel) {
      const { listen } = createChannel();

      channel = listen("ShipmentsChannel", {
        onDisconnect,
        onReceive: data => {
          if (["CREATE"].includes(data.action)) {
            dispatch(onReceive(data));
          }
        }
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/modules/OutgoingShipments/actions.js